import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';
import { AuthorizationService } from '../../../services/authorization.service';
import { UserService } from '../../../services/user.service';
import { StorageService, EnvironmentService } from '../../../services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html'
})
export class UserMenuComponent implements OnInit {

  public hasWriteAccess: boolean;
  public userFirstName: string;

  constructor(
    public authService: AuthService,
    public authorizationService: AuthorizationService,
    public userService: UserService,
    public storageService: StorageService,
    public envService: EnvironmentService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.userService.hasUserDetails().subscribe(
      (user) => {
        this.authorizationService.hasApiWriteAccess().subscribe(
          (hasWriteAccess) => {
            this.hasWriteAccess = hasWriteAccess;
          }
        );
        this.userFirstName = this.storageService.getLocalItem('firstName');
      }
    );
  }

  /**
   * Purpose: For loading Logout Service when user selects Logout User Menu
   */
  public logout() {
    this.authService.logout();
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/modules/header/user-menu/user-menu.component.ts